import { render, staticRenderFns } from "./customer-message.vue?vue&type=template&id=f7bd6c6e&"
import script from "./customer-message.vue?vue&type=script&lang=js&"
export * from "./customer-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports